<template>
    <div class="o-services-buttons services-buttons">
        <AServiceButton
            v-for="(item, index) in getServiceCategories.slice(0, 5)"
            :key="index"
            :item="item"
            @onClick="showModal"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AServiceButton from '../../atoms/a-service-button/a-service-button';

import { SHOW_MODAL } from '../../../utils/constants/bus-events-constants';

export default {
    name: "OServicesButtons",
    components: {
        AServiceButton
    },
    computed: {
        ...mapGetters([
            'getServiceCategories'
        ])
    },
    methods: {
        showModal(data) {
            const params = {
                component: 'services',
                data: {
                    ...data
                }
            };
            this.$bus.$emit(SHOW_MODAL, params);
        }
    }
}
</script>

<style lang="scss">
@import "o-services-buttons";
</style>
